import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import Swal from "sweetalert2";
import VisitorNavbar from "../component/VisitorNavbar";
import VisitorSidebar from "../component/VisitorSidebar";
import { Link } from "react-router-dom";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import { Eye, Package, Trash2 } from "react-feather";

const getBadgeClass = (status) => {
  if (!status || status.trim() === "") return "bg-primary";
  switch (status.toLowerCase()) {
    case "processing":
      return "bg-warning";
    case "out for delivery":
      return "bg-info";
    case "delivered":
      return "bg-success";
    default:
      return "bg-secondary";
  }
};

const MyOrders = () => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState("");
  const [cancelReason, setCancelReason] = useState("");

  const predefinedReasons = [
    "Ordered by mistake",
    "Product not required anymore",
    "Found a better price",
    "Expected delivery time is too long",
    "Other"
  ];

  const cust_id = localStorage.getItem("cust_id");
  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  useEffect(() => {
    $("#startDate, #endDate").datepicker({
      dateFormat: "yy-mm-dd",
      changeMonth: true,
      changeYear: true,
      onSelect: function (dateText, inst) {
        if (inst.id === "startDate") setStartDate(dateText);
        if (inst.id === "endDate") setEndDate(dateText);
      },
    });
  }, []);

  useEffect(() => {
    if (!cust_id) {
      Swal.fire("Error", "Customer ID is missing!", "error");
      return;
    }

    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${baseurl}getOrdersByUserId/${cust_id}`);
        const fetchedOrders = response.data.orders || [];
        setOrders(fetchedOrders);
        setFilteredOrders(fetchedOrders);
      } catch (error) {
        Swal.fire("Error", "Failed to load orders", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [cust_id]);

  useEffect(() => {
    let filtered = [...orders];

    if (searchId)
      filtered = filtered.filter((o) =>
        o.order_unique_id.toLowerCase().includes(searchId.toLowerCase())
      );

    if (paymentMethod)
      filtered = filtered.filter((o) => o.payment_method === paymentMethod);

    if (startDate && endDate) {
      filtered = filtered.filter((o) => {
        const orderDate = new Date(o.created_at);
        return (
          orderDate >= new Date(startDate) &&
          orderDate <= new Date(endDate + "T23:59:59")
        );
      });
    }

    if (minAmount)
      filtered = filtered.filter((o) => parseFloat(o.total) >= parseFloat(minAmount));

    if (maxAmount)
      filtered = filtered.filter((o) => parseFloat(o.total) <= parseFloat(maxAmount));

    if (sortOrder) {
      filtered.sort((a, b) => {
        if (sortOrder === "newest") return new Date(b.created_at) - new Date(a.created_at);
        if (sortOrder === "oldest") return new Date(a.created_at) - new Date(b.created_at);
        if (sortOrder === "lowtohigh") return a.total - b.total;
        if (sortOrder === "hightolow") return b.total - a.total;
        return 0;
      });
    }

    setFilteredOrders(filtered);
    setCurrentPage(1);
  }, [searchId, paymentMethod, startDate, endDate, minAmount, maxAmount, sortOrder, orders]);

  const convertPrice = (price) =>
    selectedCurrency === "USD"
      ? `$${(price / dollarRate).toFixed(2)}`
      : `₹${parseFloat(price).toFixed(2)}`;

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrders.length / recordsPerPage);

  const paginate = (pageNum) => setCurrentPage(pageNum);

  // ---------------------------
  // CANCEL ORDER MODAL HANDLING
  // ---------------------------

  const openCancelModal = (orderId) => {
    setCancelOrderId(orderId);
    setCancelReason("");
    setShowCancelModal(true);
  };

  const confirmCancelOrder = async () => {
    if (!cancelReason) {
      Swal.fire("Error", "Please select a reason!", "warning");
      return;
    }

    try {
      const response = await axios.post(`${baseurl}cancelOrder`, {
        order_id: cancelOrderId,
        reason: cancelReason,
      });

      if (response.data.success) {
        Swal.fire("Cancelled", "Your order has been cancelled.", "success");
        const res = await axios.get(`${baseurl}getOrdersByUserId/${cust_id}`);
        setOrders(res.data.orders);
        setShowCancelModal(false);
      } else {
        Swal.fire("Error", response.data.message, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to cancel order", "error");
    }
  };

  return (
    <>
      <VisitorNavbar />

      {/* Cancel Order Modal */}
      {showCancelModal && (
        <div className="modal-backdrop fade show"></div>
      )}

      {showCancelModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              
              <div className="modal-header">
                <h5 className="modal-title">Cancel Order</h5>
                <button className="btn-close" onClick={() => setShowCancelModal(false)}></button>
              </div>

              <div className="modal-body">
                <label className="fw-bold">Select a reason:</label>
                <select
                  className="form-control mt-2"
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                >
                  <option value="">Choose...</option>
                  {predefinedReasons.map((reason, idx) => (
                    <option key={idx} value={reason}>
                      {reason}
                    </option>
                  ))}
                </select>

                {cancelReason === "Other" && (
                  <textarea
                    className="form-control mt-3"
                    placeholder="Write your reason..."
                    onChange={(e) => setCancelReason(e.target.value)}
                  ></textarea>
                )}
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowCancelModal(false)}>
                  Close
                </button>
                <button className="btn btn-danger" onClick={confirmCancelOrder}>
                  Confirm Cancel
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* PAGE UI */}
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-1 justify-content-center">
              
              <div className="col-md-2 hide-on-mobile">
                <VisitorSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">My Orders</h4>
                  <p className="payttl">View your past order details.</p>

                  {/* Filters */}
                  {/* (unchanged, keeping your filters as-is) */}

                  {/* Orders Table */}
                  {loading ? (
                    <div className="text-center my-5">
                      <div className="spinner-border text-primary"></div>
                    </div>
                  ) : currentOrders.length === 0 ? (
                    <p>No orders found.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Order ID</th>
                            <th>Payment</th>
                            <th>Total</th>
                            <th>Date</th>
                            <th>Products</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentOrders.map((order, index) => (
                            <tr key={order.id}>
                              <td>{indexOfFirst + index + 1}</td>

                              <td>
                                {order.order_unique_id}
                                <br />
                                {order.tracking_link && (
                                  <a
                                    href={order.tracking_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-danger"
                                  >
                                    <Package size={15} /> Track Order
                                  </a>
                                )}
                              </td>

                              <td>{order.payment_method}</td>
                              <td>{convertPrice(order.total)}</td>
                              <td>{new Date(order.created_at).toLocaleDateString()}</td>

                              <td>
                                {order.cart_items.map((item, i) => (
                                  <div key={i} className="d-flex mb-2 align-items-start">
                                    <img
                                      src={`${imageUrl}listing/${item.image}`}
                                      alt={item.title}
                                      width="40"
                                      height="40"
                                      className="me-2 rounded"
                                    />
                                    <div>
                                      <strong>{item.title}</strong> × {item.quantity}
                                      <br />
                                      <small>
                                        {convertPrice(item.price)} + {convertPrice(item.delivery_charge)}
                                      </small>
                                      <br />
                                      {/* If order is cancelled show CANCELLED badge for all items */}
{order.cancel_status === "cancelled" ? (
  <small>
    <span className="badge bg-danger">Cancelled</span>
  </small>
) : (
  <small>
    <span className={`badge ${getBadgeClass(item.status_by_seller)}`}>
      {item.status_by_seller?.trim() || "Active"}
    </span>
  </small>
)}
                                    </div>
                                  </div>
                                ))}
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <Link
                                    to={`/performa-invoice/${order.order_unique_id}`}
                                    target="_blank"
                                    className="btn btn-sm btn-primary d-flex "
                                  >
                                    <Eye size={18} /> View
                                  </Link>

                                  {/* CANCEL BUTTON */}
                                 {/* SHOW cancel button only if NOT cancelled */}
{order.cancel_status !== "cancelled" &&
  order.cart_items.every(
    (item) => !item.status_by_seller || item.status_by_seller.trim() === ""
  ) && (
    <button
      className="btn btn-sm btn-danger ms-2 d-flex "
      onClick={() => openCancelModal(order.order_unique_id)}
    >
      <Trash2 size={18} /> Cancel
    </button>
  )
}
                                </div>
                              </td>

                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* Pagination */}
                      {totalPages > 1 && (
                        <nav>
                          <ul className="pagination justify-content-end">
                            {Array.from({ length: totalPages }, (_, i) => (
                              <li
                                key={i}
                                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                              >
                                <button className="page-link" onClick={() => paginate(i + 1)}>
                                  {i + 1}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </nav>
                      )}
                    </div>
                  )}

                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MyOrders;
